<template>
  <v-flex xs12>
    <confirmation-header-text
        class="ml-2" icon="mdi-alpha-p-box"
        text="Payment Details"
    />
    <div v-if="!paid">
      <v-layout class="ml-2" row v-if="payment_detail" wrap>
        <v-flex v-if="total_cost" xs3>
          <list-item-detail :sub_title="total_cost" title="Charge For Trekking Permit(USD)"/>
        </v-flex>
          <v-flex v-if="total_cost_npr" xs3>
          <list-item-detail :sub_title="total_cost_npr" title="Charge For Trekking Permit(NPR)"/>
        </v-flex>
        <v-flex v-if="voucherNumber" xs3>
          <list-item-detail :sub_title="voucherNumber" title="Voucher Number"/>
        </v-flex>
      </v-layout>
    </div>
    <div v-else>
      <v-layout
          v-if="payment_detail.source && payment_detail.source.toLowerCase() === 'online'"
          class="pl-3" row wrap
      >
        <v-flex sm3 xs12>
          <list-item-detail sub_title="Online payment" title="Payment method"/>
        </v-flex>
        <v-flex sm3 xs12>
          <list-item-detail :sub_title="payment_detail.transaction_detail.amount" title="Amount(USD)"/>
        </v-flex>
        <v-flex sm3 xs12>
          <list-item-detail :sub_title="payment_detail.transaction_detail.ipay_out__ipg_txn_id"
                            title="Transaction code"/>
        </v-flex>
        <v-flex sm3 xs12>
          <list-item-detail :sub_title="payment_detail.transaction_detail.ipay_out__mer_ref_id"
                            title="Merchant Reference id"/>
        </v-flex>
      </v-layout>

      <v-layout class="pl-6" row v-else-if="payment_detail.ebp_no" wrap>
        <v-flex sm3 xs12>
          <list-item-detail sub_title="Malenika" title="Payment method"/>
        </v-flex>
        <v-flex sm3 xs12>
          <list-item-detail :sub_title="payment_detail.voucher_number" title="Voucher Number"/>
        </v-flex>
        <v-flex sm3 xs12 v-if="payment_detail.paid_at">
          <list-item-detail :sub_title="payment_detail.paid_at" title="Paid at"/>
        </v-flex>
        <v-flex sm3 xs12 v-if="payment_detail.code">
          <list-item-detail :sub_title="payment_detail.ebp_no" title="EBP No"/>
        </v-flex>
        <v-flex sm3 xs12>
          <list-item-detail :sub_title="payment_detail.total_amount" title="Total amount(NPR)"/>
        </v-flex>
        <v-flex sm3 xs12 v-if="type && total_cost">
          <list-item-detail :sub_title="total_cost" title="Total amount(USD)"/>
        </v-flex>
        <v-flex sm12 xs12>
          <list-item-detail :sub_title="payment_detail.payment_description" title="Payment description"/>
        </v-flex>
      </v-layout>
    </div>
  </v-flex>
</template>
<script>
import ListItemDetail from "@/components/ListItemDetail";
import ConfirmationHeaderText from "@/components/ConfirmationHeaderText";

export default {
  name: "PaymentDetail",
  props: ['payment_detail', 'paid', 'voucherNumber', 'costExempted', 'type', 'total_cost', 'total_cost_npr'],
  computed: {
    total() {
      let {
        late_stay_cost,
        amount,
        penalty_cost,
        exempt_cost,
        transfer_cost,
        border_penalty,
        rate_amount
      } = this.payment_detail;
      rate_amount = rate_amount != undefined ? parseFloat(rate_amount) : 0;
      late_stay_cost = late_stay_cost != undefined ? parseFloat(late_stay_cost) : 0;
      penalty_cost = penalty_cost != undefined ? parseFloat(penalty_cost) : 0;
      exempt_cost = exempt_cost != undefined ? parseFloat(exempt_cost) : 0;
      transfer_cost = transfer_cost != undefined ? parseFloat(transfer_cost) : 0;
      border_penalty = border_penalty != undefined ? parseFloat(border_penalty) : 0;
      const total = rate_amount + late_stay_cost + parseFloat(amount) + penalty_cost - exempt_cost + transfer_cost + border_penalty;
      return total.toFixed(2)
    },
    visa_amount() {
      let {amount, late_stay_cost, penalty_cost, exempt_cost} = this.payment_detail;
      late_stay_cost = late_stay_cost != undefined ? parseFloat(late_stay_cost) : 0;
      penalty_cost = penalty_cost != undefined ? parseFloat(penalty_cost) : 0;
      exempt_cost = exempt_cost != undefined ? parseFloat(exempt_cost) : 0;
      const visa_amount = amount - late_stay_cost - penalty_cost + exempt_cost
      return visa_amount.toFixed(2)
    }
  }
  ,
  components: {
    ListItemDetail,
    ConfirmationHeaderText,
  },
}
</script>
